import { Input, InputProps } from 'antd'
import { useState } from 'react'
import styled from 'styled-components'
import RedInfoIcon from '../icons/RedInfoIcon'

const { TextArea } = Input

interface IWizrTextArea extends InputProps {
  placeholder?: string
  onChange?: any
  value?: any
  background?: string
  minRows?: number
  maxRows?: number
  border?: any
  onSelect?: any
  placeholderColor?: string
  padding?: string
  errorMessage?: string
  showError?: boolean
  required?: boolean
}

const StyledTextArea = styled(TextArea)<any>`
  border-radius: 16px;
  padding: 14px;
  height: 52px;
  min-height: 52px;
  resize: none !important;
  background: ${(p) => (p.background ? p.background : '#F2F4F9')};
  border: ${(p) => (p.showError ? '1px solid #ff4d4f' : p.border ? p.border : '1px solid var(--grayscale-800, #E5E7EB)')} !important;
  
  &::placeholder {
    color: ${(p) => (p.placeholderColor ? p.placeholderColor : '#A0A0A0')};
    opacity: 1; /* for full opacity */
  }

  &:hover {
    border: ${(p) => (p.showError ? '1px solid #ff4d4f' : p.border ? p.border : '1px solid var(--grayscale-800, #E5E7EB)')} !important;
  }

  &:focus {
    box-shadow: none;
    border: ${(p) => (p.showError ? '1px solid #ff4d4f' : '1px solid #000')} !important;
  }

  &:focus-within {
    border: ${(p) => (p.showError ? '1px solid #ff4d4f' : '1px solid #000')} !important;
  }
`

const ErrorText = styled.div`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  font-family: Montserrat;
  display: flex;
  align-items: center;
  gap: 6px;
`

const WizrTextArea = ({
  placeholder = '',
  onChange,
  value = '',
  background,
  minRows = 5,
  maxRows = 8,
  border,
  onSelect,
  disabled,
  placeholderColor,
  padding,
  onBlur,
  errorMessage,
  showError = false,
  required = false
}: IWizrTextArea): JSX.Element => {
  const [valueData, setValueData] = useState<string>('')

  return (
    <div style={{ width: '100%' }}>
      <StyledTextArea
        placeholder={placeholder}
        background={background}
        border={border}
        showError={showError}
        onChange={(ev: any) => {
          onChange(ev?.target?.value)
          setValueData(ev?.target?.value)
        }}
        rows={4}
        value={value ?? valueData}
        autoSize={{ minRows: minRows, maxRows: maxRows }}
        onSelect={onSelect}
        disabled={disabled}
        onBlur={onBlur}
        placeholderColor={placeholderColor}
        padding={padding}
        required={required}
      />
      {showError && errorMessage && (
        <ErrorText>
          <RedInfoIcon />
          <span>{errorMessage}</span>
        </ErrorText>
      )}
    </div>
  )
}

export default WizrTextArea
